// Cart Toast Notification Functions
const CartNotifications = {
    // Track recently shown toasts to prevent duplicates
    _recentToasts: new Set(),
    _toastDebounceTime: 500, // ms

    /**
     * Checks if a toast was recently shown to prevent duplicates
     * @param {string} type - Type of toast ('success', 'error', 'warning')
     * @param {boolean} multiple - Whether multiple products flag was used
     * @returns {boolean} - Whether this is a duplicate toast
     */
    _isDuplicate: function(type, multiple) {
        const key = `${type}-${multiple ? 'multiple' : 'single'}`;
        if (this._recentToasts.has(key)) {
            return true;
        }

        // Add to recent toasts and schedule removal
        this._recentToasts.add(key);
        setTimeout(() => {
            this._recentToasts.delete(key);
        }, this._toastDebounceTime);

        return false;
    },

    /**
     * Shows a success toast when product(s) are added to cart
     * @param {boolean} multiple - Whether multiple products were added
     */
    addedToCart: function(multiple = false) {
        // Skip if duplicate
        if (this._isDuplicate('success', multiple)) {
            return;
        }

        showToast({
            title: 'Přidáno do košíku',
            message: multiple ? 'Produkty byly úspěšně přidány do košíku.' : 'Produkt byl úspěšně přidán do košíku.',
            type: 'success'
        });
    },

    /**
     * Shows an error toast when adding to cart fails
     * @param {string} errorType - Type of error ('server' or 'product')
     */
    addToCartError: function(errorType = 'product') {
        // Skip if duplicate
        if (this._isDuplicate('error', errorType === 'items')) {
            return;
        }

        const messages = {
            server: 'Došlo k chybě při komunikaci se serverem.',
            product: 'Nepodařilo se přidat produkt do košíku.',
            items: 'Nepodařilo se přidat položky do košíku.'
        };

        showToast({
            title: 'Chyba',
            message: messages[errorType] || messages.product,
            type: 'error'
        });
    },

    /**
     * Shows a warning toast for validation errors
     * @param {string} warningType - Type of warning
     */
    warning: function(warningType = 'options') {
        // Skip if duplicate
        if (this._isDuplicate('warning', false)) {
            return;
        }

        const messages = {
            options: 'Vyberte prosím všechny možnosti produktu před přidáním do košíku'
        };

        showToast({
            title: 'Upozornění',
            message: messages[warningType] || messages.options,
            type: 'warning'
        });
    }
};

function scrollToActiveSection() {
    const accountAccordion = document.getElementById('my-account-accordion');
    if (accountAccordion) {
        setTimeout(() => {
            accountAccordion.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    }
}

// Add click handler for all accordion panels
document.querySelectorAll('#my-account-accordion .w-tabs-item.accordion-panel').forEach(panel => {
    panel.addEventListener('click', scrollToActiveSection);
});

function swapToVisible() {
    const container = document.querySelector('#my-account-accordion .w-tabs-section-content-h.i-cf');
    const children = container.children;

    for (let child of children) {
        if (child.classList.contains('order-hidden')) {
            child.classList.remove('order-hidden');
            child.classList.add('order-visible');
        } else {
            child.classList.remove('order-visible');
            child.classList.add('order-hidden');
        }
    }
    scrollToActiveSection();
}

function swapToHidden() {
    const container = document.querySelector('#my-account-accordion .w-tabs-section-content-h.i-cf');
    const children = container.children;

    for (let child of children) {
        if (child.classList.contains('order-visible')) {
            child.classList.remove('order-visible');
            child.classList.add('order-hidden');
        } else {
            child.classList.remove('order-hidden');
            child.classList.add('order-visible');
        }
    }
    scrollToActiveSection();
}

function swapToDefault() {
    const container = document.querySelector('#my-account-accordion .w-tabs-section-content-h.i-cf');
    const children = container.children;

    for (let child of children) {
        if (child.id === 'order-detail-custom-id') {
            child.classList.remove('order-visible');
            child.classList.add('order-hidden');
        } else {
            child.classList.remove('order-hidden');
            child.classList.add('order-visible');
        }
    }
    scrollToActiveSection();
}

document.querySelectorAll('.tab-item').forEach(tab => {
    tab.addEventListener('click', () => {
        // Remove active class from all tabs
        document.querySelectorAll('.tab-item').forEach(t => t.classList.remove('active'));
        document.querySelectorAll('.tab-pane').forEach(p => p.classList.remove('active'));

        // Add active class to clicked tab
        tab.classList.add('active');
        document.getElementById(tab.dataset.tab).classList.add('active');
    });
});

// Toast Notification System
function createToastContainer() {
    if (!document.querySelector('.toast-container')) {
        const container = document.createElement('div');
        container.className = 'toast-container';
        document.body.appendChild(container);
    }
}

/**
 * Activates a tab and scrolls to it based on the href attribute of the clicked link
 *
 * @param {HTMLElement} linkElement - The link element that was clicked
 * @returns {boolean} - Always returns false to prevent default link behavior
 */
function activateAndScrollToTab(linkElement) {
    // Get the target ID from the href attribute (remove the # character)
    const targetId = linkElement.getAttribute('href').substring(1);
    console.log('Activating tab with ID:', targetId);

    // Find the tab button that controls this section
    // First try by aria-controls="content-{targetId}"
    let tabButton = document.querySelector(`.w-tabs-item[aria-controls="content-${targetId}"]`);

    // If not found, try other common patterns
    if (!tabButton) {
        // Try by direct ID match
        tabButton = document.querySelector(`.w-tabs-item[id="${targetId}"]`);
    }

    if (!tabButton) {
        // Try by data attribute if available
        tabButton = document.querySelector(`.w-tabs-item[data-tab="${targetId}"]`);
    }

    console.log('Found tab button:', tabButton);

    if (tabButton) {
        // Find the tabs container for scrolling
        const tabsContainer = tabButton.closest('.w-tabs');
        console.log('Found tabs container:', tabsContainer);

        // Click the tab button to activate it
        tabButton.click();
        console.log('Clicked the tab button');

        // Scroll to the tabs container
        if (tabsContainer) {
            setTimeout(function() {
                tabsContainer.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                console.log('Scrolled to tab section');
            }, 100);
        }
    } else {
        console.log('Error: Could not find tab button for target:', targetId);
        console.log('Available tab buttons:', document.querySelectorAll('.w-tabs-item'));
    }

    // Prevent default link behavior
    return false;
}

function showToast(options = {}) {
    const {
        title = '',
        message = '',
        type = 'success',
        duration = 5000
    } = options;

    createToastContainer();
    const container = document.querySelector('.toast-container');

    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.style.setProperty('--duration', `${duration}ms`);

    // Simple icons
    const icons = {
        success: '',
        error: '×',
        warning: '!'
    };
    const icon = icons[type] || icons.success;

    toast.innerHTML = `
        <span class="toast-icon">${icon}</span>
        <div class="toast-content">
            ${title ? `<div class="toast-title">${title}</div>` : ''}
            ${message ? `<p class="toast-message">${message}</p>` : ''}
        </div>
        <button class="toast-close" aria-label="Zavřít">×</button>
    `;

    // Limit number of toasts
    const existingToasts = container.querySelectorAll('.toast');
    if (existingToasts.length >= 3) {
        removeToast(existingToasts[0]);
    }

    container.appendChild(toast);

    // Show toast with animation
    requestAnimationFrame(() => {
        toast.classList.add('show');
    });

    // Handle close button
    const closeButton = toast.querySelector('.toast-close');
    closeButton.addEventListener('click', () => {
        removeToast(toast);
    });

    // Auto remove after duration
    if (duration) {
        setTimeout(() => {
            if (document.body.contains(toast)) {
                removeToast(toast);
            }
        }, duration);
    }

    return toast;
}

function removeToast(toast) {
    toast.classList.remove('show');
    setTimeout(() => {
        toast.remove();
    }, 300); // Match transition duration
}

// Custom handler for cart update events to avoid errors with the theme
jQuery(document).ready(function($) {
    // Custom handler for added_to_cart event
    $(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {
        // If $button is null, don't try to use it
        if (!$button) {
            console.log('Added to cart event triggered without button reference');

            // Show notification - our deduplication system will prevent duplicates
            CartNotifications.addedToCart();
            return;
        }

        console.log('Added to cart with button:', $button);

        // Show toast notification - our deduplication system will prevent duplicates
        CartNotifications.addedToCart();

        // Highlight the mini cart to draw attention to it
        $('.w-cart').addClass('opened');
        setTimeout(function() {
            $('.w-cart').removeClass('opened');
        }, 1500);

        // Update cart total via AJAX
        console.log('Fetching updated cart total via AJAX');
        $.ajax({
            url: ajax_params.ajax_url,
            type: 'POST',
            data: {
                action: 'get_cart_total_ajax'
            },
            success: function (response) {
                console.log('Received updated cart total:', response);
                $('.cart-in-header-toggler-price .woocommerce-Price-amount').html(response);
            }
        });
    });

    // Custom handler for our own cart update event
    $(document.body).on('roko_cart_updated', function(event, fragments, cart_hash) {
        console.log('Roko cart updated event triggered');

        // Update mini cart count if it exists
        if (typeof updateMiniCart === 'function') {
            updateMiniCart();
        }

        // Highlight the mini cart to draw attention to it
        $('.w-cart').addClass('opened');
        setTimeout(function() {
            $('.w-cart').removeClass('opened');
        }, 1500);
    });

    // Handle click on add to cart buttons in order detail template
    $(document).on('click', '.order-item-list .add_to_cart_button.ajax_add_to_cart', function(e) {
        e.preventDefault();
        const $button = $(this);
        const productId = $button.data('product_id');
        const quantity = $button.data('quantity') || 1;

        if (productId) {
            addToCart($button, productId, quantity);
        }
    });

    // Helper function to update mini cart count
    function updateMiniCart() {
        // Use WooCommerce's native cart count, which is available in the cart fragments
        if (typeof wc_cart_fragments_params !== 'undefined') {
            // Let WooCommerce handle the fragment updates naturally
            // This gets triggered by the WooCommerce events
            return;
        }

        // Only as a fallback, try to find cart count in the DOM
        var cartCount = 0;

        // Check the cart quantity element that WooCommerce updates
        var $cartQuantity = jQuery('.w-cart-quantity');
        if ($cartQuantity.length) {
            var displayedCount = parseInt($cartQuantity.first().text(), 10);
            if (!isNaN(displayedCount) && displayedCount > 0) {
                cartCount = displayedCount;
            }
        }

        // If we have a count, use it
        if (cartCount > 0) {
            jQuery('.w-cart-quantity').text(cartCount);
            jQuery('.w-cart').removeClass('empty');
        }

        // Provide visual feedback
        jQuery('.w-cart').addClass('updated');
        setTimeout(function() {
            jQuery('.w-cart').removeClass('updated');
        }, 500);

        return cartCount;
    }

    // Initialize order detail links
    $(document).on('click', '.order-detail-link', function(e) {
        e.preventDefault();
        swapToVisible();
    });
});

function repeatOrder(orderNumber) {
    console.log('Starting repeatOrder with order number:', orderNumber);

    jQuery.ajax({
        url: ajax_params.ajax_url,
        type: 'POST',
        data: {
            action: 'roko_reorder_entire_order',
            order_id: orderNumber
        },
        beforeSend: function() {
            console.log('Before sending AJAX request');
            // Show loading state
            var $button = jQuery('#repeatOrderButton');
            console.log('Button element exists:', $button.length > 0);
            $button.addClass('loading').prop('disabled', true).text('Načítání...');
            // Remove view cart button if it exists
            jQuery('#viewCartButton, .added_to_cart.wc-forward').remove();
        },
        success: function(response) {
            console.log('AJAX success response:', response);
            var $button = jQuery('#repeatOrderButton');
            console.log('Button element in success:', $button.length > 0);

            // First reset button state
            $button.removeClass('loading').prop('disabled', false);

            if (response.success && response.fragments) {
                console.log('Fragments available:', Object.keys(response.fragments));

                // Update fragments
                jQuery.each(response.fragments, function(key, value) {
                    console.log('Replacing fragment:', key);
                    jQuery(key).replaceWith(value);
                });

                // Mark button as added
                $button.addClass('added').text('Koupit znovu');

                // Show success message
                jQuery('.woocommerce-notices-wrapper').html('<div class="woocommerce-message" role="alert">Produkty byly přidány do košíku.</div>');

                // Show success toast
                CartNotifications.addedToCart(true);

                // Add standard WooCommerce "View Cart" button after the "Repeat Order" button
                if (!jQuery('.added_to_cart.wc-forward').length) {
                    var cartUrl = response.cart_url || wc_add_to_cart_params.cart_url || '/kosik/';
                    $button.after('<a href="' + cartUrl + '" class="added_to_cart wc-forward" title="Zobrazit košík">Zobrazit košík</a>');
                }

                // Trigger standard WooCommerce events to refresh fragments
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);
            } else {
                console.log('Response error or no fragments');
                // Reset button text
                $button.text('Koupit znovu');
                // Show error message
                jQuery('.woocommerce-notices-wrapper').html('<div class="woocommerce-error" role="alert">Nepodařilo se přidat položky do košíku.</div>');
                // Show error toast
                CartNotifications.addToCartError('items');
                // Remove view cart button if it exists
                jQuery('.added_to_cart.wc-forward').remove();
            }
        },
        error: function(xhr, status, error) {
            console.log('AJAX error:', status, error);
            console.log('Response text:', xhr.responseText);
            // Show error message
            jQuery('.woocommerce-notices-wrapper').html('<div class="woocommerce-error" role="alert">Došlo k chybě při komunikaci se serverem.</div>');
            // Show error toast
            CartNotifications.addToCartError('server');
            // Remove view cart button if it exists
            jQuery('.added_to_cart.wc-forward').remove();
            // Reset button state
            var $button = jQuery('#repeatOrderButton');
            $button.removeClass('loading').prop('disabled', false).text('Koupit znovu');
        }
    });
}

function addToCart($button, productId, quantity = 1) {
    if (!productId) return;

    jQuery.ajax({
        url: ajax_params.ajax_url,
        type: 'POST',
        data: {
            action: 'add_to_cart',
            product_id: productId,
            quantity: quantity
        },
        beforeSend: function() {
            $button.addClass('loading').prop('disabled', true);
            // Remove any existing view cart button
            $button.next('.added_to_cart.wc-forward').remove();
        },
        success: function(response) {
            if (response.success) {
                $button.addClass('added');

                // Let WooCommerce handle fragment updates
                if (response.fragments) {
                    jQuery.each(response.fragments, function(key, value) {
                        jQuery(key).replaceWith(value);
                    });
                }

                // Add standard WooCommerce "View Cart" button
                if (!$button.next('.added_to_cart.wc-forward').length) {
                    var cartUrl = response.cart_url || wc_add_to_cart_params.cart_url || '/kosik/';
                    $button.after('<a href="' + cartUrl + '" class="added_to_cart wc-forward" title="Zobrazit košík">Zobrazit košík</a>');
                }

                // Show success toast
                CartNotifications.addedToCart();

                // Trigger standard WooCommerce events to refresh fragments
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);
            } else {
                CartNotifications.addToCartError('product');
            }
        },
        error: function() {
            CartNotifications.addToCartError('server');
        },
        complete: function() {
            $button.removeClass('loading').prop('disabled', false);
        }
    });
}

/**
 * Product Summary Functionality
 *
 * This section contains JavaScript functions for the product summary component
 * that are used in the product detail pages.
 */

// Initialize all product summary components when the DOM is ready
jQuery(function($) {
    // Product quantity controls
    initProductQuantityControls();

    // Product variant selection for variable products
    initVariantSelection();

    // Update quantity on add to cart buttons
    initQuantityUpdateOnCart();

    // Add our new initialization
    // initDynamicPriceUpdate();
});

/**
 * Initialize quantity control buttons (plus/minus) in the product summary
 */
function initProductQuantityControls() {
    // Remove any existing handlers first
    jQuery(document).off('click', '.roko-quantity-minus, .roko-quantity-plus');

    // Add our handler
    jQuery(document).on('click', '.roko-quantity-minus, .roko-quantity-plus', function() {
        // Get the input and current value
        var $input = jQuery(this).closest('.roko-quantity-controls').find('.roko-quantity-input');
        var currentVal = parseFloat($input.val()) || 0;
        var max = parseFloat($input.attr('max'));
        var min = parseFloat($input.attr('min')) || 1;
        var step = parseFloat($input.attr('step')) || 1;

        // Increment or decrement
        if (jQuery(this).hasClass('roko-quantity-plus')) {
            if (max && (currentVal >= max)) {
                $input.val(max);
            } else {
                $input.val(currentVal + step);
            }
        } else {
            if (currentVal > min) {
                $input.val(currentVal - step);
            } else {
                $input.val(min);
            }
        }

        // Trigger change event
        $input.trigger('change');
    });
}

/**
 * Initialize variable product add to cart functionality
 */
function initVariantSelection() {
    jQuery(document).on('click', '.w-btn.us-btn-style_1.variable-product', function(e) {
        e.preventDefault();

        var $button = jQuery(this);
        var productId = $button.data('product_id');
        var quantity = jQuery('.roko-quantity-input').val() || 1;

        // Collect the variation data
        var variationData = {};
        var allSelected = true;

        jQuery('.roko-variant-select').each(function() {
            var name = jQuery(this).attr('name');
            var value = jQuery(this).val();
            if (name && value) {
                variationData[name] = value;
            } else {
                allSelected = false;
                return false; // Exit the loop
            }
        });

        if (!allSelected) {
            CartNotifications.warning('options');
            return;
        }

        $button.addClass('loading');

        // Use native WooCommerce AJAX to add variable product to cart
        var data = {
            action: 'woocommerce_add_to_cart',
            product_id: productId,
            quantity: quantity,
            variation_id: '', // This will be determined by WooCommerce based on attributes
        };

        // Add all variation attributes to the data
        jQuery.each(variationData, function(key, value) {
            data['attribute_' + key] = value;
        });

        jQuery.ajax({
            type: 'POST',
            url: wc_add_to_cart_params.ajax_url,
            data: data,
            success: function(response) {
                if (response.error && response.product_url) {
                    window.location = response.product_url;
                    return;
                }

                // Show success message
                $button.removeClass('loading').addClass('added');

                // Show success toast
                CartNotifications.addedToCart();

                // Trigger standard WooCommerce events to refresh fragments
                jQuery(document.body).trigger('added_to_cart', [response.fragments, response.cart_hash, $button]);
            },
            error: function() {
                $button.removeClass('loading');
                // Replace alert with toast notification
                CartNotifications.addToCartError('product');
            }
        });
    });
}

/**
 * Initialize quantity update on cart buttons when quantity changes
 */
function initQuantityUpdateOnCart() {
    // Remove any existing handlers first
    jQuery(document).off('change', '.roko-quantity-input');

    jQuery(document).on('change', '.roko-quantity-input', function() {
        var quantity = jQuery(this).val() || 1;
        jQuery('.w-btn.us-btn-style_1.ajax_add_to_cart').attr('data-quantity', quantity);
    });

    // Hook into WooCommerce's added_to_cart event for styling the button
    jQuery(document.body).on('added_to_cart', function(event, fragments, cart_hash, $button) {
        if ($button && $button.hasClass('w-btn')) {
            $button.addClass('added');
        }
    });
}

/**
 * Initialize color picker functionality
 */
function initColorPicker() {
    // Color picker functionality
    jQuery('.roko-color-option').on('click', function() {
        jQuery('.roko-color-option').removeClass('selected');
        jQuery(this).addClass('selected');
    });
}

/**
 * Initialize dynamic price updates based on quantity changes
 */
function initDynamicPriceUpdate() {
    jQuery(document).on('change', '.roko-quantity-input', function() {
        updatePricesBasedOnQuantity(jQuery(this).val());
    });

    // Also handle clicks on the quantity buttons
    jQuery(document).on('click', '.roko-quantity-minus, .roko-quantity-plus', function() {
        // The click handler for quantity buttons already triggers the change event
        // So we don't need to update prices here directly
    });

    // Initialize with default quantity
    updatePricesBasedOnQuantity(jQuery('.roko-quantity-input').val() || 1);
}

/**
 * Update displayed prices based on the selected quantity
 *
 * @param {number} quantity - The selected quantity
 */
function updatePricesBasedOnQuantity(quantity) {
    quantity = parseInt(quantity) || 1;

    const $priceDisplay = jQuery('.roko-product-price-display');
    if (!$priceDisplay.length) return;

    // Get base prices from data attributes
    const basePrice = parseFloat($priceDisplay.data('base-price')) || 0;
    const basePriceExclTax = parseFloat($priceDisplay.data('base-price-excl-tax')) || 0;
    const baseMemberPrice = parseFloat($priceDisplay.data('member-price')) || 0;

    // Calculate total prices based on quantity
    const totalPrice = basePrice * quantity;
    const totalPriceExclTax = basePriceExclTax * quantity;
    const totalMemberPrice = baseMemberPrice * quantity;

    // Format prices (uses WooCommerce's price format)
    const formattedPrice = formatPrice(totalPrice);
    const formattedPriceExclTax = formatPrice(totalPriceExclTax);
    const formattedMemberPrice = formatPrice(totalMemberPrice);

    // Update the displayed prices
    $priceDisplay.find('.roko-price-amount').html(formattedPrice);
    $priceDisplay.find('.roko-price-tax-info').html(formattedPriceExclTax + ' ' + 'bez DPH');
    $priceDisplay.find('.roko-price-member-amount').html(formattedMemberPrice);
}

/**
 * Format price according to WooCommerce settings
 * This is a simplified version - WooCommerce has more complex formatting
 *
 * @param {number} price - The price to format
 * @return {string} - Formatted price
 */
function formatPrice(price) {
    // Get WooCommerce currency symbol if available
    const currencySymbol = typeof woocommerce_price_slider_params !== 'undefined'
        ? woocommerce_price_slider_params.currency_symbol
        : 'Kč';

    // Format price with 2 decimal places
    const formattedPrice = price.toFixed(2).replace('.', ',');

    // Return formatted price with currency
    return formattedPrice + ' ' + currencySymbol;
}

// Expose functions to global scope for inline event handlers
// --- Roko Popular Products Visibility Toggle START (Simple & Performant) ---
document.addEventListener('DOMContentLoaded', function() {
  const popularProductsSection = document.getElementById('roko-popular-products-section');
  const sidebarFilterForm = document.querySelector('.roko-category-filters .roko-filter-form');

  // Exit if elements aren't present
  if (!popularProductsSection || !sidebarFilterForm) {
    return;
  }

  const priceSlider = sidebarFilterForm.querySelector('.roko-price-slider');
  const volumeSlider = sidebarFilterForm.querySelector('.roko-volume-slider');
  const resetLink = sidebarFilterForm.querySelector('.roko-reset-filters');

  // --- Helper Function: Check if any sidebar filter is active ---
  function isSidebarFilterActive() {
    // 1. Check Checkboxes/Radios (any checked input within the sidebar form)
    if (sidebarFilterForm.querySelector('input[type="checkbox"]:checked, input[type="radio"]:checked')) {
      return true;
    }

    // 2. Check Price Slider (compare current values to defaults)
    if (priceSlider) {
      const minInput = sidebarFilterForm.querySelector(priceSlider.dataset.minField || '#price-min');
      const maxInput = sidebarFilterForm.querySelector(priceSlider.dataset.maxField || '#price-max');
      const defaultMin = parseFloat(priceSlider.dataset.minPrice);
      const defaultMax = parseFloat(priceSlider.dataset.maxPrice);
      const currentMin = parseFloat(minInput?.value);
      const currentMax = parseFloat(maxInput?.value);

      // Active if a valid current value is different from default (moved inwards)
      if ((!isNaN(currentMin) && currentMin > defaultMin) || (!isNaN(currentMax) && currentMax < defaultMax)) {
        return true;
      }
    }

    // 3. Check Volume/Weight Slider (compare current values to defaults)
    if (volumeSlider) {
      const minInput = sidebarFilterForm.querySelector(volumeSlider.dataset.minField || '#volume-min');
      const maxInput = sidebarFilterForm.querySelector(volumeSlider.dataset.maxField || '#volume-max');
      // Use direct float comparison
      const defaultMin = parseFloat(volumeSlider.dataset.minVolume);
      const defaultMax = parseFloat(volumeSlider.dataset.maxVolume);
      const currentMin = parseFloat(minInput?.value);
      const currentMax = parseFloat(maxInput?.value);

       // Active if a valid current value is different from default (moved inwards)
      if ((!isNaN(currentMin) && currentMin > defaultMin) || (!isNaN(currentMax) && currentMax < defaultMax)) {
        return true;
      }
    }
    // Add checks for other relevant input types within sidebarFilterForm if necessary (e.g., selects with non-default value)

    return false; // No active sidebar filters detected
  }

  // --- Helper Function: Update Visibility Class ---
  function updatePopularProductsVisibility() {
    if (isSidebarFilterActive()) {
      popularProductsSection.classList.add('hidden-by-filter');
    } else {
      popularProductsSection.classList.remove('hidden-by-filter');
    }
  }

  // --- Event Listeners ---

  // Listen for slider changes via the 'slidersReady' custom event bridge
   document.addEventListener('slidersReady', function() {
        if (priceSlider && typeof jQuery !== 'undefined') {
             jQuery(priceSlider).off('slidechange.visibilityToggle');
        }
        if (volumeSlider && typeof jQuery !== 'undefined') {
             jQuery(volumeSlider).off('slidechange.visibilityToggle');
        }
   });

  // Remove the direct change listener
  if (sidebarFilterForm) {
    sidebarFilterForm.removeEventListener('change', updatePopularProductsVisibility);
  }

  // Listen for the signal that the main filter AJAX/UI update is done
  document.addEventListener('roko_filter_update_complete', function() {
    // Re-evaluate sidebar state AFTER the main filter system might have updated the form
    // The existing updatePopularProductsVisibility function already checks the sidebar state
    updatePopularProductsVisibility();
  });

  // Listen for reset link click
  if (resetLink) {
    resetLink.addEventListener('click', function() {
      // Remove class instantly for perceived responsiveness before navigation
      popularProductsSection.classList.remove('hidden-by-filter');
    });
  }

  // Listen for the signal that the main filter AJAX/UI update is done
  document.addEventListener('roko_filter_update_complete', function() {
    // Re-evaluate sidebar state AFTER the main filter system might have updated the form
    // The existing updatePopularProductsVisibility function already checks the sidebar state
    updatePopularProductsVisibility();
  });

  // --- Initial State Check ---
  updatePopularProductsVisibility();

});
// --- Roko Popular Products Visibility Toggle END ---

// --- Mobile Filter Toggle START ---
  const filterToggleButton = document.getElementById('roko-mobile-filter-toggle');
  const filterPanel = document.getElementById('roko-collapsible-filters-panel');

  if (filterToggleButton && filterPanel) {
    filterToggleButton.addEventListener('click', function() {
      const isExpanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', !isExpanded);
      filterPanel.classList.toggle('is-open');
      this.classList.toggle('is-active'); // For hamburger icon animation

      // Optional: Add class to body to prevent scroll if panel is fixed/overlay
      // document.body.classList.toggle('roko-filters-open-overlay');
    });

    // Optional: Implement close on Escape key
    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && filterPanel.classList.contains('is-open')) {
        filterToggleButton.click(); // Simulate click to close
      }
    });
  }
// --- Mobile Filter Toggle END ---
